export default __webpack_public_path__ + "static/media/trophy.945027ad.png";